/**
 * 快捷键一览。
 *
 * 为什么要有这一页：快捷键只在按钮 hover 的 title 里露出，等于「你得先知道有这个键才会去看」。
 * 腾讯会议在设置里放了完整列表，用户找得到。
 */

import { isMac } from '../lib/platform'

/** 修饰键在 Mac 上显示 ⌘、其它平台显示 Ctrl —— 显示成 "Ctrl/⌘" 两个都写反而要用户自己挑。 */
const MOD = isMac() ? '⌘' : 'Ctrl'

const KEYS: Array<{ keys: string; what: string; note?: string }> = [
  { keys: `${MOD} + D`, what: '开关麦克风' },
  { keys: `${MOD} + E`, what: '开关摄像头' },
  { keys: '按住空格', what: '临时说话', note: '仅在已开麦且处于静音时有效，松开即恢复静音' },
  { keys: `${MOD} + Shift + S`, what: '开始 / 停止共享屏幕', note: '需要共享权限' },
  { keys: `${MOD} + Shift + H`, what: '打开交流区' },
  { keys: `${MOD} + U`, what: '显示 / 收起成员列表' },
  { keys: `${MOD} + Shift + K`, what: '举手 / 放下手', note: '自由发言模式下有效' },
  { keys: 'Shift + F', what: '视频区全屏 / 退出全屏' },
  { keys: 'Esc', what: '退出全屏、关闭当前弹层' },
]

export function HotkeyHelp({ onClose }: { onClose: () => void }) {
  return (
    <div className="dlg-mask" onClick={onClose} role="presentation">
      <div className="dlg" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="快捷键">
        <h3>快捷键</h3>
        <table className="hk-table">
          <tbody>
            {KEYS.map((k) => (
              <tr key={k.keys}>
                <td className="hk-keys"><kbd>{k.keys}</kbd></td>
                <td>
                  {k.what}
                  {k.note && <span className="hk-note">{k.note}</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="adm-hint">在聊天框里打字时快捷键全部失效，不会误触。</p>
        <div className="dlg-foot">
          <button className="primary" onClick={onClose}>知道了</button>
        </div>
      </div>
    </div>
  )
}
